import React from "react";
import classnames from "classnames";

import { useManualUserTracking } from "../../hooks/useTracking";
import { MANUAL_EVENT } from "../../helpers/userTrack";

const UserProfile = ({ profile, isActive, onChangeProfile, current }) => {
  // const { 
  //   profile,
  //   isActive,
  //   onChangeProfile,
  // } = props; 

  const { trackUserEvent } = useManualUserTracking();

  const handleChangeProfile = (id) => {
    trackUserEvent({type: MANUAL_EVENT.CHANGE_PROFILE, currentProfile: current, selectedProfile: profile });
    onChangeProfile(id);
  };
  
  return (
    <div
      onClick={isActive ? 
        null :
        () => handleChangeProfile(profile.id) 
      } 
      className={classnames(
        "profile-box",
        { 'active': isActive },
      )}>
      <div className="profile-avatar">
        <span className="profile-avatar-user">
          <i className="nav-icon-user" />
        </span>
      </div>
      <div className="profile-name">
        {profile.givenName}
      </div>
      <div className="profile-lastname">
        {profile.familyName}
      </div>
    </div>
  );
};

export default UserProfile;